/** @module                             i18n */

import { useTranslation }               from "react-i18next";

/** @module                             Components */

import { LabeledInput }                 from "../../Global/Forms/Inputs_Spread";

/** @module                             Helpers */

import { camelize }                     from "./Pricing_Utils";

/**
 * 
 * The price settings that are a single number and therefore have their own column on
 * `delivery_plans`. Country maps live in `pricing` and are edited by PricingFields.
 * 
 */

const 

/** settings that must stay whole numbers */

WHOLE_NUMBER_FIELDS = [ "bulk_discount_from" ],

/** handled by its own section rather than listed with the rest */

MASTER_FIELDS = [ "master_price_enabled", "master_price" ],

/**
 * 
 * @param { Array } fields
 * 
 * @param { Object } values
 * 
 * @param { Function } onChange
 * 
 * @param { Boolean } disabled
 * 
 * @returns the scalar price fields of one delivery method
 * 
 */

PriceFields = ( { fields = [], values = {}, onChange, disabled = false } ) => { const { t } = useTranslation (),

    listed = fields.filter ( field => ! MASTER_FIELDS.includes ( field ) );

    if ( ! listed.length ) return null;

    /** @returns */

    return ( <div className="pricing-group">

        <div className="pricing-group__title">

            { t ( "delivery_pricing_shared" ) }

        </div>

        <div className="pricing-grid">

            { listed.map ( field => <ScalarPriceInput 
            
                key={ field } field={ field } values={ values } onChange={ onChange } disabled={ disabled } /> ) }

        </div>

    </div> );

},

/**
 * 
 * @returns one scalar price input
 * 
 */

ScalarPriceInput = ( { field, values, onChange, disabled } ) => { const name = camelize ( field );

    /** @returns */

    return ( <LabeledInput 

        type="text"

        inputMode={ WHOLE_NUMBER_FIELDS.includes ( field ) ? "numeric" : "decimal" }

        label={ `delivery_pricing_${ field }` }

        value={ values [ name ] ?? "" }

        disabled={ disabled }

        action={ event => onChange ( name, event.target.value ) } /> );

};

/** @exports PriceFields */

export { WHOLE_NUMBER_FIELDS, MASTER_FIELDS };

export default PriceFields;
